import { sql as vercelSql } from '@vercel/postgres';

// Check if we have a database connection string
const isDbConnected = !!process.env.POSTGRES_URL;

/**
 * Mock SQL tagged template literal for local development without a DB
 */
const mockSql = (strings: TemplateStringsArray, ...values: any[]): any => {
    console.warn('⚠️ Using Mock SQL - No POSTGRES_URL found in environment.');
    return {
        rows: [],
        rowCount: 0
    };
};

/**
 * Mock query function for dynamic SQL
 */
const mockQuery = async (text: string, values: any[] = []): Promise<any> => {
    console.warn('⚠️ Using Mock Query - No POSTGRES_URL found in environment.');
    return {
        rows: [],
        rowCount: 0
    };
};

// Export the real SQL utility or a mock version
export const sql = isDbConnected
    ? vercelSql
    : Object.assign(mockSql, { query: mockQuery });

/**
 * Helper to ensure database connection is available
 */
export const checkConnection = async () => {
    if (!isDbConnected) return false;
    try {
        const { rows } = await vercelSql`SELECT 1 as connected`;
        return rows[0].connected === 1;
    } catch (error) {
        console.error('Database connection error:', error);
        return false;
    }
};
